import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import {ViewService} from "../../../services/common/view.service";


// type Layout =
//   "chip-lbl" |
//   "item";


@Component({
  selector: 'app-popover-select',
  templateUrl: './popover-select.component.html',
  styleUrls: ['./popover-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoverSelectComponent implements OnInit {


  // component args

  @Input() opts;



  // listener

  listener = {
    view: null,
  };


  constructor(
    private cd: ChangeDetectorRef,
    // private navCtrl: NavController,
    // navParams can only be used in modals and popovers!
    // private navParams: NavParams,
    // private tdweb: TdwebService,
    // private dataService: DataService,
    private popoverCtrl: PopoverController,
    // private alertCtrl: AlertController,
    // private modalCtrl: ModalController,
    // private api: ApiService,
    private view: ViewService,
    // private menuCtrl: MenuController,
  ) {}



  ngOnInit() {}


  ionViewWillEnter() {
  }


  ionViewDidEnter() {
    this.listenerView();
  }


  ionViewWillLeave() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }


  ionViewDidLeave() {
  }


  // ngOnDestroy() {}





  /*myFunc() {
    console.log("myfunc", typeof this.val == 'number')
    return typeof this.val == 'number';
  }*/




  async dismiss(id: string, data: any) {
    await this.popoverCtrl.dismiss({
      id: id,
      data: data ? data : ''
    })
  }




  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }
















}
